import type { SVGProps } from "react";
export const ArrowLeftAlt = (props: SVGProps<SVGSVGElement>) => (
	<svg
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 24 24"
		aria-hidden={true}
		{...props}
	>
		<path
			d="M9.95185 17.6538L4.29785 12L9.95185 6.34625L11.0056 7.43075L7.18635 11.25H19.7019V12.75H7.18635L11.0056 16.5693L9.95185 17.6538Z"
			fill="currentColor"
		/>
	</svg>
);
